export default "__VITE_ASSET__BFYcCz5k__"